import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import {
  CustomBorderWrapper, FullSizeRelativeWrapper, FullHeightAlignCenterColumn, Mt1,
  WhiteSpaceNoWrap, FlexCenterWrapper, Mr2, AbsoluteRightTopWrapper, CustomHeight,
  FullWIdthColumnScrollWrapper, BorderBottomWrapper, FlexCenterBetweenWrapper, Pb4,
  Mb2, Mt4, Px4, Ml2, CursorPointerWrapper, GenericWrapper, Mt2, CustomBackgroundWrapper,
  FullWidthFlexCenterBetweenWrapper, P6, AbsoluteLeftTopWrapper, FitRelativeWrapper
} from 'wrappers';
import {
  SecondaryTextSm300, SecondaryTextLg, Icon, SecondaryTextLgBold, SecondaryTextSm400,
  SecondaryTextSm, SecondaryTextXs, RedTextXs, ClickableIcon
} from 'atoms';
import internalState from './internalState';
import React from 'react';
import {
  DollarSignSvg, DownloadDocumentSvg, GreenTickSvg, ExclamationMarkSvg, ChevronDownSvg,
  ChevronUpSvg
} from 'components/icons';
import { formatPrice, getAreasWithCost, getTotalCost, getIsMobile, colorShade } from 'utils';
import { SolidButton } from 'molecules';

const isMobile = getIsMobile();

const containerRef = React.createRef();

export const definition = {
  name: 'TotalCostDropdown',
  controller: Controller,
  initialProps: ({ inspection, hideCosts }) => ({ inspection, hideCosts }),
  props: internalState,
  elements: [
    {
      wrapper: isMobile ? FitRelativeWrapper : FullSizeRelativeWrapper,
      name: '__transparent__',
      ref: containerRef,
      elements: [
        {
          wrapper: CustomBorderWrapper,
          name: 'Selector',
          isButton: true,
          bindings: ({ isOpen }) => ({ isOpen, containerRef }),
          displayState: ({ }) => ({ cursor: 'pointer' }),
          elements: [
            {
              wrapper: FullHeightAlignCenterColumn,
              displayState: ({ }) => ({ alignDirection: 'start' }),
              name: 'DisplayComponent',
              elements: [
                {
                  component: Icon,
                  name: 'Icon',
                  renderIf: ({ }) => isMobile,
                  displayValue: ({ }) => DollarSignSvg({ width: 18, height: 18, color: window?.settings?.primary_color ?? '#1DBD6B' })
                },
                {
                  component: isMobile ? wrap(SecondaryTextXs, Mt2) : wrap(SecondaryTextSm300, WhiteSpaceNoWrap),
                  name: 'Title',
                  displayValue: ({ }) => isMobile ? 'COST' : 'TOTAL COST'
                },
                {
                  wrapper: wrap(FlexCenterWrapper, Mt1),
                  name: '__transparent__',
                  elements: [
                    {
                      component: wrap(Icon, Mr2),
                      name: 'Icon',
                      renderIf: ({ }) => !isMobile,
                      displayValue: ({ }) => DollarSignSvg({ width: 18, height: 18, color: window?.settings?.secondary_color ?? '#04333B' })
                    },
                    {
                      component: isMobile ? SecondaryTextSm : SecondaryTextLg,
                      name: 'Cost',
                      displayValue: ({ inspection }) => {
                        if (!inspection.has_charges) {
                          return '-'
                        }
                        let total = getTotalCost(inspection?.items ?? []);
                        if (total !== null) {
                          return `$${formatPrice(total / 100, true)}`
                        }
                        return '-'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          wrapper: isMobile ? AbsoluteLeftTopWrapper : AbsoluteRightTopWrapper,
          displayState: ({ }) => ({ top: '50px', zIndex: 12 }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({ borderRadius: '12px', border: '1px solid #E3E3E3', background: '#FFFFFF' }),
              elements: [
                {
                  wrapper: CustomHeight,
                  name: 'ListWrapper',
                  renderIf: ({ inspection }) => getAreasWithCost(inspection).length > 0 && inspection.has_charges,
                  displayState: ({ }) => ({ maxHeight: 420, width: isMobile ? '300px' : '280px', display: 'flex', flexDirection: 'column' }),
                  elements: [
                    {
                      wrapper: CustomBackgroundWrapper,
                      name: 'Errors',
                      renderIf: ({ inspection, hideCosts }) => {
                        let filteredItems = inspection.items.filter(i => (!i.posted_on || i.post_error) && i.options.find(o => o.name === i.status)?.cost_in_cents > 0)
                        if (filteredItems.length === 0) return false;
                        if (hideCosts) return false;
                        let noItemPosted = true;
                        inspection.items.map(i => {
                          if (i.posted_on && !i.post_error) {
                            noItemPosted = false;
                          }
                        })
                        return !noItemPosted;
                      },
                      displayState: ({ }) => ({ background: '#FFF4F4', padding: '12px 24px', width: '100%' }),
                      elements: [
                        {
                          wrapper: FullWidthFlexCenterBetweenWrapper,
                          name: '__transparent__',
                          elements: [
                            {
                              wrapper: FlexCenterWrapper,
                              name: 'LeftSide',
                              elements: [
                                {
                                  component: wrap(Icon, Mr2),
                                  name: 'Icon',
                                  displayValue: ({ }) => ExclamationMarkSvg({ plain: true })
                                },
                                {
                                  component: SecondaryTextXs,
                                  name: 'Text',
                                  displayValue: ({ inspection, messageIndex }) => {
                                    let filteredItems = inspection.items.filter(i => (!i.posted_on || i.post_error) && i.options.find(o => o.name === i.status)?.cost_in_cents > 0)
                                    let message = `${filteredItems.length} charges not posted`;
                                    if (messageIndex > 0) {
                                      message = `${filteredItems[messageIndex - 1].area} - ${filteredItems[messageIndex - 1].name}`
                                    }
                                    return message;
                                  }
                                }
                              ]
                            },
                            {
                              wrapper: FlexCenterWrapper,
                              name: 'RightSide',
                              elements: [
                                {
                                  component: wrap(ClickableIcon, Mr2),
                                  name: 'Down',
                                  bindings: ({ messageIndex, inspection }) => ({ messageIndex, inspection }),
                                  displayValue: ({ messageIndex, inspection }) => ChevronDownSvg({ color: messageIndex === inspection.items.filter(i => (!i.posted_on || i.post_error) && i.options.find(o => o.name === i.status)?.cost_in_cents > 0).length ? colorShade(0.5, window?.settings?.secondary_color ?? '#04333b') : window?.settings?.secondary_color ?? '#04333b' })
                                },
                                {
                                  component: ClickableIcon,
                                  name: 'Up',
                                  bindings: ({ messageIndex }) => ({ messageIndex }),
                                  displayValue: ({ messageIndex }) => ChevronUpSvg({ color: messageIndex === 0 ? colorShade(0.5, window?.settings?.secondary_color ?? '#04333b') : window?.settings?.secondary_color ?? '#04333b' })
                                },
                              ]
                            },
                          ]
                        }
                      ]
                    },
                    {
                      wrapper: FullWIdthColumnScrollWrapper,
                      displayState: ({ }) => ({ flexGrow: 1, height: 'unset' }),
                      name: 'ListWrapper',
                      elements: [
                        {
                          wrapper: wrap(wrap(wrap(Mb2, BorderBottomWrapper), Mt4), Px4),
                          name: 'AreaWrapper',
                          isListOf: { area: ({ inspection }) => getAreasWithCost(inspection) },
                          elements: [
                            {
                              wrapper: wrap(FlexCenterBetweenWrapper, Pb4),
                              name: 'AreaTotal',
                              elements: [
                                {
                                  component: SecondaryTextLgBold,
                                  name: 'AreaTitle',
                                  displayValue: ({ area }) => area.title
                                },
                                {
                                  component: SecondaryTextLgBold,
                                  name: 'AreaPrice',
                                  displayValue: ({ area }) => `$${formatPrice(area.cost / 100, true)}`,
                                }
                              ]
                            },
                            {
                              wrapper: wrap(FlexCenterBetweenWrapper, Pb4),
                              name: 'AreaTotal',
                              isListOf: 'area.items',
                              elements: [
                                {
                                  component: SecondaryTextSm400,
                                  name: 'AreaTitle',
                                  displayValue: ({ item }) => item.name
                                },
                                {
                                  wrapper: FlexCenterWrapper,
                                  name: '__transparent__',
                                  elements: [
                                    {
                                      component: wrap(SecondaryTextSm400, Mr2),
                                      name: 'AreaPrice',
                                      displayValue: ({ item }) => {
                                        let option = item.options.find(o => o.name === item.status);
                                        return `$${formatPrice(option?.cost_in_cents / 100, true)}`
                                      }
                                    },
                                    {
                                      component: Icon,
                                      name: 'Icon',
                                      renderIf: ({ inspection, item }) => {
                                        let noItemPosted = true;
                                        inspection.items.map(i => {
                                          let option = item.options.find(o => o.name === item.status);
                                          if (option.cost_in_cents === 0) return false;
                                          if (i.posted_on && !i.post_error) {
                                            noItemPosted = false;
                                          }
                                        })
                                        return !noItemPosted;
                                      },
                                      displayValue: ({ item }) => {
                                        if (item.posted_on && !item.post_error)
                                          return GreenTickSvg({ color: '#1DBD6B' })
                                        return ExclamationMarkSvg({ plain: true })
                                      }
                                    }

                                  ]
                                }
                              ]
                            },
                          ]
                        }
                      ]
                    },
                  ]
                },
                {
                  wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, Px4), Pb4), Mt2),
                  name: 'ButtonsWrapper',
                  renderIf: ({ inspection }) => {
                    let total = getTotalCost(inspection?.items ?? []);
                    if (getAreasWithCost(inspection).length === 0 || total === 0 || !inspection.has_charges) {
                      return false;
                    }
                    return true
                  },
                  elements: [
                    {
                      wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
                      name: 'Export',
                      isButton: true,
                      bindings: ({ inspection }) => ({ inspection }),
                      elements: [
                        {
                          component: wrap(SecondaryTextXs, Mr2),
                          name: 'Text',
                          displayValue: ({ }) => 'Export'
                        },
                        {
                          component: Icon,
                          name: 'Icon',
                          displayValue: ({ }) => DownloadDocumentSvg({})
                        }
                      ]
                    },
                    {
                      wrapper: GenericWrapper,
                      name: '__transparent__',
                      elements: [
                        {
                          component: wrap(SolidButton, WhiteSpaceNoWrap),
                          name: 'Button',
                          renderIf: ({ hideCosts }) => !hideCosts,
                          bindings: ({ inspection }) => {
                            let disabled = !inspection.unit_id || (!inspection.incoming_resident && !inspection.outgoing_resident);
                            let filteredItems = inspection.items.filter(i => (!i.posted_on || i.post_error) && i.options.find(o => o.name === i.status)?.cost_in_cents > 0)

                            let title = 'Post more charges';

                            let noItemPosted = true;
                            inspection.items.map(i => {
                              if (i.posted_on && !i.post_error) {
                                noItemPosted = false;
                              }
                            })

                            if (noItemPosted) {
                              title = 'Post charges';
                            }

                            if (filteredItems.length === 0) {
                              disabled = true;
                              title = 'All charges posted';
                            }
                            return ({ title, disabled })
                          },
                          displayState: ({ inspection }) => {
                            let filteredItems = inspection.items.filter(i => (!i.posted_on || i.post_error) && i.options.find(o => o.name === i.status)?.cost_in_cents > 0)
                            return { disabled: !inspection.unit_id || (!inspection.incoming_resident && !inspection.outgoing_resident) || filteredItems.length === 0 }
                          }
                        },
                        {
                          component: wrap(RedTextXs, Mt2),
                          name: 'ErrorText',
                          renderIf: ({ inspection }) => !inspection.unit_id || (!inspection.incoming_resident && !inspection.outgoing_resident),
                          displayValue: ({ inspection }) => !inspection.unit_id ? 'Property inspection' : 'No resident'
                        }
                      ]
                    }
                  ]
                },
                {
                  component: wrap(wrap(SecondaryTextSm400, WhiteSpaceNoWrap), P6),
                  name: 'NothingText',
                  renderIf: ({ inspection }) => getAreasWithCost(inspection).length === 0 || !inspection.has_charges,
                  displayValue: ({ }) => 'Nothing to see here'
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

export default ContainerComponent(definition)